// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import axios from 'axios'
import { Icon, Collapse, CollapseItem, Loading, Message, Table, TableColumn, Tabs, TabPane, Dialog, Button, Input,Radio,RadioGroup } from 'element-ui';
import JsonViewer from 'vue-json-viewer'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/swiper-bundle.min.css'
import './assets/css/base.less'
import './assets/css/sub.css'

import menuData from '../static/menu.js';

Vue.use(Icon)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Loading)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Input)
Vue.use(Radio)
Vue.use(RadioGroup)

Vue.use(JsonViewer)
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$message = Message;
Vue.prototype.$menuData = menuData;

const uuid_gomain = '/apqi/';
// const uuid_gomain = 'http://192.168.100.33:28001/';
// const uuid_gomain = 'http://39.100.29.118:28001/';
// Vue.prototype.$ocrDomainNames = 'http://39.100.29.118:28001/';
// Vue.prototype.$ocrDomainNames = 'http://192.168.3.3:28001/';
Vue.prototype.$ocrDomainNames = uuid_gomain;
Vue.prototype.$dataDomainNames = uuid_gomain;
// Vue.prototype.$dataDomainNames = 'http://39.100.29.118:28001/';


router.afterEach((to, from, next) => {
  // var routerList = to.matched;
  // if(routerList.length > 0){
  //   store.commit("setMenuFirstIndex" , routerList[0].meta.index);
  //   store.commit("setMenuSecondIndex" , routerList[1].meta.en_name);
  // }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js